import { useTranslation } from 'react-i18next';
import { object, boolean } from 'yup';
import { PaymentMethods } from '@models/PaymentMethod';
import { FormValues } from './type';

export const useFormValues = () => {
  const values: FormValues = {
    agreeToTermsAndConditions: false,
    paymentMethod: PaymentMethods.AbaPay,
  };
  return values;
};

export const useValidationSchema = () => {
  const { t } = useTranslation();

  return object({
    agreeToTermsAndConditions: boolean().test(
      'required',
      t('validation:required'),
      (checked) => checked === true,
    ),
  });
}
